import { FC } from "react";
import { SmallVideoBlock } from "@/api/generated-api";
import S from "./index.module.scss";
import clsx from "clsx";

interface ITechnologySmallVideo {
  data: SmallVideoBlock;
}

const TechnologySmallVideo: FC<ITechnologySmallVideo> = ({ data }) => {
  const { reverse, image, content } = data;

  return (
    <div className={S.block}>
      <div className={clsx(S.imageContainer, { [S["imageContainer--reverse"]]: reverse })}>
        <video className={S.video} autoPlay loop muted>
          <source src={image} />
        </video>
      </div>
      {content && (
        <div
          className={clsx(S.content, { [S["content--reverse"]]: reverse })}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}
    </div>
  );
};

export default TechnologySmallVideo;
